export default {
  addSample: 'Stichprobe hinzufügen',
  createOneTimePart: 'Einmaliges Teil erstellen',
  sample: {
    defaultDisplayName: 'Stichprobe',
  },
  tableTest: {
    defaultDisplayName: 'Tabelle',
  },
  chartTest: {
    defaultDisplayName: 'Diagramm',
  },
  imageTest: {
    defaultDisplayName: 'Bild',
  },
  fileTest: {
    defaultDisplayName: 'Datei',
  },
};
